import footerDesktopImg from "./footer-desktop.png";
import footerMobileImg from "./footer-mobile.png";

export const footerImages = {
  footerDesktopImg,
  footerMobileImg,
};
